module Meevo.Plugins.EmmaAccountSettings {
    export class EmailMarketingSubmitModalController {
        static $inject = [
            "$mdDialog",
            "meevo.components.common.DataService",
            "meevo.AppSettings",
            "meevo.components.common.IdentityService",
            "meevo.components.busy.BusyService",
            "meevo.components.common.SecurityService",
            "meevo.components.modal.ModalService",
            "options",
            "$timeout",
            "$translate",
            "meevoDateFilterFilter",
            "$mdBottomSheet",
            "$rootElement"
        ];

        public model: Model.IEmmaSMSAccountSettings;

        public legalEntityTypeList = [
            { label: 'Private Company', value: 'LEGAL_ENTITY_TYPE_PRIVATE_COMPANY' },
            { label: 'Public Company', value: 'LEGAL_ENTITY_TYPE_PUBLIC_COMPANY' },
            { label: 'Non-Profit', value: 'LEGAL_ENTITY_TYPE_NON_PROFIT' },
            { label: 'Government', value: 'LEGAL_ENTITY_TYPE_GOVERNMENT' },
            { label: 'Sole Proprietor', value: 'LEGAL_ENTITY_TYPE_SOLE_PROPRIETOR' }
        ];

        constructor(
            private $mdDialog: angular.material.IDialogService,
            public dataService: Meevo.Components.BaseClasses.IDataService,
            private appSettings: Meevo.Components.Common.IAppSettings,
            public identityService: Meevo.Components.Common.IIdentityService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            private securityService: Meevo.Components.Common.ISecurityService,
            public modalService: Meevo.Components.Modal.IModalService,
            public options: Meevo.Model.NotificationSetting,
            public $timeout: angular.ITimeoutService,
            public $translate: ng.translate.ITranslateService,
            public meevoDateFilter: any,
            public $mdBottomSheet: angular.material.IBottomSheetService,
            public $rootElement: angular.IRootElementService) {
            this.loadData();
        }

        loadData() {
            this.dataService.customMethodData(`${this.appSettings.API_ROOT}/SMSMarketing/RegistrationInfo`, "GET", null)
                .then(result => {
                    if (result && result.data) {
                        this.model = result.data;
                        this.model.storeName = result.data.name || null;
                        this.model.tenantId = this.identityService.current().tenantId || null;

                        if (result.data.address.countryCode === "1") {
                            this.model.businessRegistrationType = "BUSINESS_REGISTRATION_TYPE_EIN";
                        }
                    }
                });

            
        }

        save() {
            if (Model.Guard.isNothing(this.model.storeName)
                || Model.Guard.isNothing(this.model.contactFirstName)
                || Model.Guard.isNothing(this.model.contactLastName)
                || Model.Guard.isNothing(this.model.address.address1)
                || Model.Guard.isNothing(this.model.address.city)
                || Model.Guard.isNothing(this.model.address.state)
                || Model.Guard.isNothing(this.model.address.zipCode)
                || Model.Guard.isNothing(this.model.address.country)
                || Model.Guard.isNothing(this.model.emailAddress)
                || Model.Guard.isNothing(this.model.webAddressUrl)
                || Model.Guard.isNothing(this.model.phoneNumber)
                || Model.Guard.isNothing(this.model.countryCode)
                || Model.Guard.isNothing(this.model.taxId)
                || Model.Guard.isNothing(this.model.legalEntityType)) {
                this.modalService.alert("MESSAGE_VERIFICATION_MISSING_INFO", Components.Modal.ModalTranslationModes.Translate, true);
                return;
            }

            // Validate taxId: must be 9 characters or in format XX-XXXXXXX
            if (this.model.taxId) {
                const nineCharRegex = /^.{9}$/;
                const einFormatRegex = /^\d{2}-\d{7}$/;
                if (!nineCharRegex.test(this.model.taxId) && !einFormatRegex.test(this.model.taxId)) {
                    this.modalService.alert("MESSAGE_TAXID_WRONG_FORMAT", Components.Modal.ModalTranslationModes.Translate, true);
                    return;
                }
            }
            return this.modalService
                .confirm("MESSAGE_SUBMIT_VERIFICATION", Components.Modal.ModalTranslationModes.Translate, true)
                .then(result => {
                    if (result) {
                        return this.postData();
                    }
                });

        }

        postData() {
            return this.dataService
                .customMethodData(`${this.appSettings.API_ROOT}/SMSMarketing/RegistrationInfo/Submit`, "POST", this.model)
                .then(response => {
                    return this.$mdDialog.hide(response)
                });
        }

        closeModal(e): void {
            if (e) e.stopPropagation();
            this.$mdDialog.hide();
        }

    }

    angular.module("meevo.plugins.emmaAccountSettings")
        .controller("meevo.plugins.emmaAccountSettings.EmailMarketingSubmitModalController", EmailMarketingSubmitModalController);
}